module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Fruehstueck-QV.ab9052ba.jpg";